var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.selectedChatroom ? _c('div', {
    staticClass: "sidebox pt-3"
  }, [_c('b-modal', {
    attrs: {
      "id": "modal-showImg",
      "ok-title": "關閉",
      "centered": "",
      "ok-only": ""
    }
  }, [_c('img', {
    staticStyle: {
      "width": "480px"
    },
    attrs: {
      "src": _vm.currentImg
    }
  })]), _c('b-modal', {
    attrs: {
      "id": "modal-nickname",
      "title": "自訂暱稱",
      "ok-title": "儲存",
      "cancel-title": "取消",
      "centered": ""
    },
    on: {
      "ok": _vm.handleUpdateCustomerProfile,
      "hidden": _vm.handleCloseUpdateNickname
    }
  }, [_c('b-input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20",
      "placeholder": "自訂暱稱不會向對方公開"
    },
    model: {
      value: _vm.inputNickname,
      callback: function callback($$v) {
        _vm.inputNickname = $$v;
      },
      expression: "inputNickname"
    }
  })], 1), _c('b-modal', {
    attrs: {
      "id": "modal-edit-field",
      "title": (_vm.editingField && _vm.editingField.title) + (_vm.editingField && _vm.editingField.required ? '*' : '') || '編輯',
      "ok-title": "儲存",
      "cancel-title": "取消",
      "centered": ""
    },
    on: {
      "ok": _vm.handleSaveEditingField
    }
  }, [_vm.editingField ? _c('div', [_vm.editingField.memo ? _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.editingField.memo))]) : _vm._e(), _vm.editingField.type === 'text' ? _c('b-form-input', {
    attrs: {
      "disabled": _vm.editingField.disabled
    },
    on: {
      "input": _vm.handleEditingFieldChanged
    },
    model: {
      value: _vm.editingValue,
      callback: function callback($$v) {
        _vm.editingValue = $$v;
      },
      expression: "editingValue"
    }
  }) : _vm._e(), _vm.editingField.type === 'select' ? _c('b-form-select', {
    attrs: {
      "options": _vm.editingField.options,
      "disabled": _vm.editingField.disabled
    },
    on: {
      "input": _vm.handleEditingFieldChanged
    },
    model: {
      value: _vm.editingValue,
      callback: function callback($$v) {
        _vm.editingValue = $$v;
      },
      expression: "editingValue"
    }
  }) : _vm._e(), _vm.editingField.type === 'radio' ? _c('b-form-radio-group', {
    attrs: {
      "options": _vm.editingField.options,
      "disabled": _vm.editingField.disabled
    },
    on: {
      "input": _vm.handleEditingFieldChanged
    },
    model: {
      value: _vm.editingValue,
      callback: function callback($$v) {
        _vm.editingValue = $$v;
      },
      expression: "editingValue"
    }
  }) : _vm._e(), _vm.editingField.type === 'checkbox' ? _c('b-form-checkbox-group', {
    attrs: {
      "options": _vm.editingField.options,
      "disabled": _vm.editingField.disabled
    },
    on: {
      "input": _vm.handleEditingFieldChanged
    },
    model: {
      value: _vm.editingValue,
      callback: function callback($$v) {
        _vm.editingValue = $$v;
      },
      expression: "editingValue"
    }
  }) : _vm._e(), _vm.editingField.type === 'textarea' ? _c('b-form-textarea', {
    staticClass: "liff-reservation-form__textarea",
    attrs: {
      "rows": "5"
    },
    on: {
      "input": _vm.handleEditingFieldChanged
    },
    model: {
      value: _vm.editingValue,
      callback: function callback($$v) {
        _vm.editingValue = $$v;
      },
      expression: "editingValue"
    }
  }) : _vm._e(), _vm.editingField.type === 'date' ? _c('datepicker', {
    attrs: {
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh
    },
    on: {
      "input": _vm.handleEditingFieldChanged
    },
    model: {
      value: _vm.editingValue,
      callback: function callback($$v) {
        _vm.editingValue = $$v;
      },
      expression: "editingValue"
    }
  }) : _vm._e(), _vm.editingField.type === 'tags' ? _c('b-form-tags', {
    attrs: {
      "tag-variant": "dark",
      "remove-on-delete": "",
      "separator": " ,;"
    },
    on: {
      "input": _vm.handleEditingFieldChanged
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var tags = _ref.tags,
          inputAttrs = _ref.inputAttrs,
          inputHandlers = _ref.inputHandlers,
          removeTag = _ref.removeTag;
        return [_c('div', {
          staticClass: "d-flex flex-wrap align-items-center"
        }, [_vm._l(tags, function (tag) {
          return _c('b-badge', {
            key: tag,
            staticClass: "mr-2 mb-1",
            attrs: {
              "variant": "dark"
            }
          }, [_vm._v(" " + _vm._s(tag) + " "), _c('button', {
            staticClass: "btn btn-xs p-0",
            on: {
              "click": function click($event) {
                return removeTag(tag);
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-remove text-white"
          })])]);
        }), _c('input', _vm._g(_vm._b({
          staticClass: "form-control border-0 shadow-none flex-grow-1",
          attrs: {
            "placeholder": "輸入標籤"
          }
        }, 'input', inputAttrs, false), inputHandlers))], 2)];
      }
    }], null, false, 4096229133),
    model: {
      value: _vm.editingValue,
      callback: function callback($$v) {
        _vm.editingValue = $$v;
      },
      expression: "editingValue"
    }
  }) : _vm._e(), _vm.validationErrorMessage ? _c('div', {
    staticClass: "text-danger mt-2",
    staticStyle: {
      "font-size": "0.75rem"
    }
  }, [_vm._v(" " + _vm._s(_vm.validationErrorMessage) + " ")]) : _vm._e()], 1) : _vm._e()]), _c('b-modal', {
    attrs: {
      "id": "modal-tags",
      "title": "編輯標籤",
      "ok-title": "儲存",
      "cancel-title": "取消",
      "centered": ""
    },
    on: {
      "ok": _vm.handleSaveTags
    }
  }, [_c('div', {
    staticClass: "border rounded p-1"
  }, [_vm._l(_vm.tagsWithoutDuplicate, function (tag, index) {
    return _c('b-badge', {
      key: tag,
      staticClass: "m-1",
      attrs: {
        "variant": "dark"
      }
    }, [_vm._v(" " + _vm._s(tag) + " "), _c('button', {
      staticClass: "btn btn-xs p-0",
      on: {
        "click": function click($event) {
          return _vm.handleClickRemoveTag(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove text-white"
    })])]);
  }), _c('b-input', {
    staticClass: "border-0",
    attrs: {
      "type": "text",
      "maxlength": "40",
      "placeholder": "輸入標籤"
    },
    on: {
      "keyup": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleEnterInputTag.apply(null, arguments);
      }, _vm.handleKeyUpInputTag],
      "blur": _vm.handleEnterInputTag
    },
    model: {
      value: _vm.inputTag,
      callback: function callback($$v) {
        _vm.inputTag = $$v;
      },
      expression: "inputTag"
    }
  })], 2)]), _vm.showMemberListInDashboard || _vm.showFileListInDashboard ? _c('b-tabs', {
    staticClass: "h-100 d-flex flex-column overflow-y-hidden",
    attrs: {
      "content-class": "flex-fill overflow-y-auto overflow-x-hidden pl-2"
    }
  }, [_vm.showMemberListInDashboard ? _c('b-tab', {
    attrs: {
      "title": "成員",
      "title-item-class": "px-2"
    }
  }, [!_vm.selectedMember ? _c('b-list-group', [_vm.loading ? _c('div', {
    staticClass: "text-center mt-3 mb-3 loading-spinner"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "secondary",
      "small": ""
    }
  })], 1) : _c('div', [_vm.canShowAddMemberButton ? _c('ChatroomAddMember', {
    attrs: {
      "chatroom": _vm.selectedChatroom,
      "disabled": _vm.disabledAddMemberButton
    },
    on: {
      "added": function added($event) {
        _vm.fetchCustomers();
        _vm.fetchStaffs();
      }
    }
  }) : _vm._e(), _vm._l(_vm.staffs, function (staff) {
    return _c('b-list-group-item', {
      key: staff.id,
      staticClass: "d-flex align-items-center border-0",
      attrs: {
        "href": "#"
      }
    }, [_c('b-avatar', {
      staticClass: "mr-1",
      class: staff.is_enabled ? '' : 'gray-mask',
      attrs: {
        "src": staff.avatar_url
      }
    }), _c('div', {
      staticClass: "mr-auto font-weight-bold text-nowrap text-truncate pr-2"
    }, [_vm._v(" " + _vm._s(staff.name) + " ")]), _c('div', {
      staticClass: "text-nowrap"
    }, [_vm.chatroomConfig.invite_staff_in_dashboard_permission_role && _vm.canShowRemoveMemberButton && staff.role !== _vm.chatroomConfig.invite_staff_in_dashboard_permission_role ? _c('b-button', {
      staticClass: "p-1 mr-2",
      attrs: {
        "size": "xs",
        "pill": "",
        "variant": "danger"
      },
      on: {
        "click": function click($event) {
          return _vm.removeMember(staff);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times m-0"
    })]) : _vm._e()], 1)], 1);
  }), _vm._l(_vm.customers, function (customer) {
    return _c('b-list-group-item', {
      key: customer.id,
      staticClass: "d-flex align-items-center border-0",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function click($event) {
          return _vm.handleSelectMember(customer.id);
        }
      }
    }, [_c('b-avatar', {
      staticClass: "mr-1",
      class: customer.is_enabled ? '' : 'gray-mask',
      attrs: {
        "src": customer.avatar_url
      }
    }), _c('div', {
      staticClass: "mr-auto font-weight-bold text-nowrap text-truncate pr-2"
    }, [_vm._v(" " + _vm._s(customer.name) + " ")]), _c('div', {
      staticClass: "text-nowrap"
    }, [_c('i', {
      staticClass: "fa fa-angle-right",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1);
  })], 2)]) : _vm._e(), _vm.selectedMember ? _c('div', {
    staticClass: "profile"
  }, [_c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": function click($event) {
        _vm.selectedMember = false;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 回列表 ")]), _c('div', {
    staticClass: "text-center p-3"
  }, [_c('b-avatar', {
    staticClass: "my-4",
    attrs: {
      "size": "8rem",
      "src": _vm.customer.avatar_url
    }
  }), _c('div', {
    staticClass: "h4 p-2 text-left"
  }, [_c('h6', {
    staticClass: "mb-2"
  }, [_vm._v("LINE 名稱：" + _vm._s(_vm.customer.name))]), _c('div', {
    staticClass: "take-type-categories"
  }, [_vm.normalFields.length ? _c('div', {
    staticClass: "take-type-category"
  }, [_c('h6', {
    staticClass: "category-title"
  }, [_c('span', {
    attrs: {
      "id": "customer-info"
    }
  }, [_vm._v("客戶帳號資料 "), _c('span', {
    staticClass: "mdi mdi-help-circle-outline"
  })])]), _c('b-tooltip', {
    attrs: {
      "target": "customer-info",
      "placement": "top"
    }
  }, [_vm._v(" 此區內容為共用資訊，其他人也能看到 ")]), _c('div', {
    staticClass: "category-options-row"
  }, _vm._l(_vm.normalFields, function (field, index) {
    return _c('h6', {
      key: 'field' + index,
      staticClass: "m-0"
    }, [_vm._v(" " + _vm._s(field.title) + _vm._s(field.required ? ' *' : '') + "："), _c('SaveText', {
      attrs: {
        "status": _vm.saveStatus[field.matched_key]
      }
    }), field.type === 'checkbox' || field.type === 'tags' ? _c('span', [_vm._v(_vm._s(_vm.formatValue(_vm.getValue(field))))]) : _c('span', {
      style: {
        whiteSpace: field.type === 'textarea' ? 'pre-line' : 'normal'
      }
    }, [_vm._v(_vm._s(_vm.getValue(field)))]), _c('button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modal-edit-field",
        modifiers: {
          "modal-edit-field": true
        }
      }],
      staticClass: "btn m-0",
      attrs: {
        "hidden": !_vm.$permissions.has(_vm.$permissions.consts.CHATROOM_LIST_CHAT_MODIFY_CUSTOMER_PROFILE)
      },
      on: {
        "click": function click($event) {
          return _vm.openEditField(field);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1);
  }), 0)], 1) : _vm._e(), _vm.staffExtraFields.length ? _c('div', {
    staticClass: "take-type-category"
  }, [_c('h6', {
    staticClass: "category-title"
  }, [_c('span', {
    attrs: {
      "id": "my-personal-remark"
    }
  }, [_vm._v("我的私人備註 "), _c('span', {
    staticClass: "mdi mdi-help-circle-outline"
  })])]), _c('b-tooltip', {
    attrs: {
      "target": "my-personal-remark",
      "placement": "top"
    }
  }, [_vm._v(" 此區為您的個人備註，內容不會對他人公開 ")]), _c('div', {
    staticClass: "category-options-row"
  }, _vm._l(_vm.staffExtraFields, function (field, index) {
    return _c('h6', {
      key: 'field' + index,
      staticClass: "m-0"
    }, [_vm._v(" " + _vm._s(field.title) + "："), _c('SaveText', {
      attrs: {
        "status": _vm.saveStatus[field.matched_key]
      }
    }), field.type !== 'checkbox' && field.type !== 'tags' ? _c('span', [_vm._v(_vm._s(_vm.getValue(field)))]) : _c('span', [_vm._v(_vm._s(_vm.formatValue(_vm.getValue(field))))]), _c('button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modal-edit-field",
        modifiers: {
          "modal-edit-field": true
        }
      }],
      staticClass: "btn m-0",
      attrs: {
        "hidden": !_vm.$permissions.has(_vm.$permissions.consts.CHATROOM_LIST_CHAT_MODIFY_CUSTOMER_PROFILE)
      },
      on: {
        "click": function click($event) {
          return _vm.openEditField(field);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1);
  }), 0)], 1) : _vm._e(), _c('div', {
    staticClass: "take-type-category"
  }, [_c('h6', {
    staticClass: "category-title"
  }, [_vm._v("標籤"), _c('SaveText', {
    attrs: {
      "status": _vm.saveStatus.tags
    }
  })], 1), _c('div', {
    staticClass: "category-options-row"
  }, [_vm._l(_vm.orderedTags, function (tag) {
    return _c('b-badge', {
      key: tag,
      staticClass: "m-1",
      attrs: {
        "variant": "dark"
      }
    }, [_vm._v(_vm._s(tag))]);
  }), _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-tags",
      modifiers: {
        "modal-tags": true
      }
    }],
    staticClass: "btn",
    attrs: {
      "hidden": !_vm.$permissions.has(_vm.$permissions.consts.CHATROOM_LIST_CHAT_MODIFY_CUSTOMER_PROFILE)
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)])])])], 1), _c('b-list-group', {
    staticClass: "border-top border-bottom accordion",
    attrs: {
      "id": "accordionExample",
      "flush": ""
    }
  }, [_c('b-list-group-item', {
    attrs: {
      "role": "button"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "hidden": !_vm.$permissions.has(_vm.$permissions.consts.CHATROOM_LIST_CHAT_MODIFY_CUSTOMER_PROFILE)
    },
    on: {
      "click": _vm.handleClickSaveCustomer
    }
  }, [_vm._v(" 儲存 ")])])], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm.showFileListInDashboard ? _c('b-tab', {
    attrs: {
      "title": "檔案",
      "title-item-class": "px-2"
    },
    on: {
      "click": _vm.fetchFileList
    }
  }, [_c('b-list-group', [_vm.loading ? _c('div', {
    staticClass: "text-center mt-3 mb-3 loading-spinner"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "secondary",
      "small": ""
    }
  })], 1) : _c('div', _vm._l(_vm.fileList, function (file, i) {
    return _c('b-list-group-item', {
      key: i,
      staticClass: "d-flex align-items-center border-0",
      attrs: {
        "href": _vm.catFileType(file.mime) === 'jpg' ? '' : file.url
      }
    }, [_vm.catFileType(file.mime) === 'csv' ? _c('img', {
      staticClass: "mr-2 file-type-icon",
      attrs: {
        "src": require("@/assets/images/file_type_icons/csv.png")
      }
    }) : _vm._e(), _vm.catFileType(file.mime) === 'doc' ? _c('img', {
      staticClass: "mr-2 file-type-icon",
      attrs: {
        "src": require("@/assets/images/file_type_icons/doc.png")
      }
    }) : _vm._e(), _vm.catFileType(file.mime) === 'file' ? _c('img', {
      staticClass: "mr-2 file-type-icon",
      attrs: {
        "src": require("@/assets/images/file_type_icons/file.png")
      }
    }) : _vm._e(), _vm.catFileType(file.mime) === 'jpg' ? _c('img', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modal-showImg",
        modifiers: {
          "modal-showImg": true
        }
      }],
      staticClass: "mr-2 file-type-icon",
      attrs: {
        "src": file.url
      },
      on: {
        "click": function click($event) {
          _vm.currentImg = file.url;
        }
      }
    }) : _vm._e(), _vm.catFileType(file.mime) === 'pdf' ? _c('img', {
      staticClass: "mr-2 file-type-icon",
      attrs: {
        "src": require("@/assets/images/file_type_icons/pdf.png")
      }
    }) : _vm._e(), _vm.catFileType(file.mime) === 'ppt' ? _c('img', {
      staticClass: "mr-2 file-type-icon",
      attrs: {
        "src": require("@/assets/images/file_type_icons/ppt.png")
      }
    }) : _vm._e(), _vm.catFileType(file.mime) === 'txt' ? _c('img', {
      staticClass: "mr-2 file-type-icon",
      attrs: {
        "src": require("@/assets/images/file_type_icons/txt.png")
      }
    }) : _vm._e(), _vm.catFileType(file.mime) === 'xls' ? _c('img', {
      staticClass: "mr-2 file-type-icon",
      attrs: {
        "src": require("@/assets/images/file_type_icons/xls.png")
      }
    }) : _vm._e(), _vm.catFileType(file.mime) === 'zip' ? _c('img', {
      staticClass: "mr-2 file-type-icon",
      attrs: {
        "src": require("@/assets/images/file_type_icons/zip.png")
      }
    }) : _vm._e(), _c('div', {
      staticClass: "d-flex flex-column lh-sm-0 text-truncate"
    }, [_c('div', {
      staticClass: "mr-auto font-weight-bold"
    }, [_vm._v(" " + _vm._s(file.name) + " ")]), _c('div', {
      staticClass: "small text-muted"
    }, [_vm._v(_vm._s(file.sender.name))]), _c('div', {
      staticClass: "small text-muted"
    }, [_vm._v(_vm._s(_vm.formatDateD(file.created_at)))])])]);
  }), 1)]), _c('b-pagination', {
    staticClass: "separated mb-md-0 align-self-center py-3",
    attrs: {
      "total-rows": _vm.total,
      "per-page": _vm.perPage
    },
    on: {
      "change": _vm.handleChangePage
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }